import React from "react"

import { createLucideIcon, ListFilter } from "lucide-react"

// Official Lucide TagPlus icon, backported because our pinned release predates it: https://lucide.dev/icons/tag-plus
const TagPlus = createLucideIcon("TagPlus", [
  ["path", { d: "M16 13h6", key: "1um0mj" }],
  [
    "path",
    {
      d: "m16.5 6.5-3.914-3.914A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l1.79-1.79",
      key: "dp0yc9",
    },
  ],
  ["path", { d: "M19 10v6", key: "13mz7b" }],
  [
    "circle",
    {
      cx: "7.5",
      cy: "7.5",
      r: ".5",
      fill: "currentColor",
      key: "kqv944",
    },
  ],
])

/** The shared icon for filtering a resource list by one or more tags. */
export const FilterByTagIcon: React.FC<{ className?: string }> = ({
  className,
}) => <ListFilter className={className} />

/** The shared icon for assigning tags to one or more resources. */
export const AddTagIcon: React.FC<{ className?: string }> = ({ className }) => (
  <TagPlus className={className} />
)
